<script setup lang="ts">
import { useCourseStore } from '../stores/courseStore';
import { useRouter } from 'vue-router';

const store = useCourseStore();
const router = useRouter();

const menuItems = [
  { id: 'courseplan', label: 'Mein Kursplan', route: '/' },
  { id: 'stay', label: 'Mein Aufenthalt', route: '/stay' },
  { id: 'massage', label: 'Meine Massagen', route: '/massage' },
  { id: 'yogatherapy', label: 'Meine Yogatherapie', route: '/yogatherapy' },
  { id: 'rides', label: 'Mitfahrgelegenheiten', route: '/rides' },
  { id: 'feedback', label: 'Mein Feedback', route: '/feedback' },
  { id: 'past-courses', label: 'Vergangene Kurse', route: '/past-courses' },
  { id: 'about', label: 'Über uns', route: '/about' },
];

const handleMenuClick = (route: string) => {
  store.menuOpen = false;
  router.push(route);
};
</script>

<template>
  <div
    v-if="store.menuOpen"
    class="menu-overlay"
    @click="store.menuOpen = false"
  >
    <div class="menu-content" @click.stop>
      <button
        v-for="item in menuItems"
        :key="item.id"
        class="menu-item"
        @click="handleMenuClick(item.route)"
      >
        {{ item.label }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.menu-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 250px;
}

.menu-item {
  background: none;
  border: none;
  padding: 1rem;
  cursor: pointer;
  text-align: center;
  font-size: 1.1em;
  color: #960040;
}

.menu-item:hover {
  background: #f0f0f0;
}
</style>